export default "__VITE_ASSET__D4h$RArY__"